<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">

    <form [formGroup]="formularioEndeudamiento" (ngSubmit)="onSubmit()">
      <div class="grid form-group">
        <p-checkbox
          label="{{ this.labelIndicador }}"
          binary="true"
          id="indicadorNivelEndeudamiento"
          name="indicadorNivelEndeudamiento"
          formControlName="indicadorNivelEndeudamiento">
        </p-checkbox>
        <div class="col-12 md:col-6 lg:col-6 text-center" *ngIf="!segmento.indicadorHabilitado && !detalle">
          <button type="submit" pButton label="{{ 'BTN_GUARDAR' | translate}}" ></button>
        </div>
      </div>
    </form>
  </div>
</div>

